module.exports = __webpack_public_path__ + "static/media/catalogueImg9.7dba18ad.png";